import { render, staticRenderFns } from "./DeductionTimingRecord.vue?vue&type=template&id=869ad6d6&scoped=true&"
import script from "./DeductionTimingRecord.vue?vue&type=script&lang=js&"
export * from "./DeductionTimingRecord.vue?vue&type=script&lang=js&"
import style0 from "./DeductionTimingRecord.vue?vue&type=style&index=0&id=869ad6d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869ad6d6",
  null
  
)

export default component.exports